e4.gtm = {
    init: function () {
        if ( window.google_tag_manager !== undefined ) {
            e4.gtm.bindEvents();
        }
    },
    bindEvents: function () {
        jQuery( document )
            .on( 'userauthenticated.e4.login', e4.gtm.login )
            .on( 'productadded.e4.cart', e4.gtm.ecom.addProduct )
            .on( 'productremoved.e4.cart', e4.gtm.ecom.removeProduct );
        jQuery( '.js-e-search-form' )
            .on( 'loaded.e4.search', e4.gtm.search );
        jQuery( '.js-e-checkout, .js-e-checkout-receipt' )
            .on( [
                'stepchanged.e4.checkout',
                'receiptshown.e4.checkout'
            ].join( ' ' ), e4.gtm.ecom.checkoutStep );
    },
    pushDataLayer: function ( objDataLayer ) {
        // console.log( objDataLayer )
        if ( window.dataLayer !== undefined ) {
            dataLayer.push( objDataLayer );
        }
    },
    login: function () {
        e4.gtm.pushDataLayer( {
            'LoggedOn': 'OK',
            'event': 'LoggedOnDone'
        } );
    },
    search: function ( event, objData ) {
        e4.gtm.pushDataLayer( {
            'event': 'VirtualPageviewSearch',
            'virtualPageSearchURL': '/search?q=' + objData.query,
            'virtualPageSearchTitle': 'Search'
        } );
        if ( objData.resultCount === 0 ) {
            e4.gtm.pushDataLayer( {
                'eventCategory': 'Search - Zero results',
                'eventAction': objData.query,
                'eventLabel': '{{Page URL}}',
                'eventValue': 0,
                'eventInteraction': true,
                'event': 'track-ga-event'
            } );
        }
    },
    ecom: {
        // https://developers.google.com/tag-manager/enhanced-ecommerce#cart
        addProduct: function ( event, objData ) {
            // console.log( 'GTM: Add product', objData );
            e4.gtm.pushDataLayer( {
                'event': 'addToCart',
                'ecommerce': {
                    'currencyCode': objData.cart.currencyCode,
                    'add': {
                        'products': [
                            {
                                'name': objData.cart.lastAdded[ 0 ].name,
                                'id': objData.cart.lastAdded[ 0 ].number,
                                'price': objData.cart.lastAdded[ 0 ].priceClean,
                                'quantity': objData.cart.lastAdded[ 0 ].quantity
                            }
                        ]
                    }
                }
            } );
        },
        removeProduct: function ( event, objData ) {
            // console.log( 'GTM: Remove product', objData );
            e4.gtm.pushDataLayer( {
                'event': 'removeFromCart',
                'ecommerce': {
                    'currencyCode': objData.CurrencyCode,
                    'remove': {
                        'products': [
                            {
                                'name': objData.Name,
                                'id': objData.Number,
                                'price': objData.Price,
                                'quantity': objData.Quantity
                            }
                        ]
                    }
                }
            } );
        },
        checkoutStep: function ( event, objData ) {
            var objVirtualPageview = {
                    'event': 'VirtualPageview',
                    'vpevent': 'VirtualPageview',
                    'virtualPageURL': '/shop/cart/checkout?step=' + objData.index + ' ' + objData.name,
                    'virtualPageTitle': 'Order Step ' + objData.index + ' – ' + objData.name
                },
                objCheckout = {
                    'event': 'checkout',
                    'ecommerce': {
                        'checkout': {
                            'actionField': {
                                'step': objData.index
                            }
                        }
                    }
                };
            e4.gtm.pushDataLayer( objVirtualPageview );
            e4.gtm.pushDataLayer( objCheckout );
        }
    }
};
